import React, { useState } from "react";
import { ReactComponent as Arrow } from "../../assets/technologies/arrow.svg";
import { ReactComponent as Arrowdn } from "../../assets/technologies/arrowDn.svg";
import "./Accordion.scss";

const Accordion = ({ content, fill }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className="accordion-item">
      <div className="accordion-header" onClick={() => setIsActive(!isActive)}>
        <div style={{ cursor: "pointer" }}>
          {isActive ? <Arrowdn fill={fill} /> : <Arrow fill={fill} />}
        </div>
      </div>
      {isActive && <div className="accordion-content">{content}</div>}
    </div>
  );
};

export default Accordion;
